import { Show, SimpleShowLayout, TextField } from 'react-admin';

export const ImportShow = () => (
  <Show>
    <SimpleShowLayout>
      <TextField source="name" />
    </SimpleShowLayout>
  </Show>
);
